import Color from 'color';
import styled, { css } from 'styled-components';

export const topBarColor = '#1685ec';
export const topBarColor2 = Color('#1685ec').darken(0.5).toString();
export const topBar = 50;
export const topBarHeight = `${topBar}px`;
export const borderColor = '#858585';
export const bgColor = Color('#f7f6fb').lighten(0.0075).toString();
export const borderColor2 = Color('#f7f6fb').darken(0.15).toString();
export const bgColor2 = Color('lightgrey').lighten(0.1).toString();
export const logRes1 = '925px';
export const auditsPanelMobileHeight = '66px';
export const metricsPanelMobileHeight = auditsPanelMobileHeight;
/** Shared width for Metrics, Audits, Reporting, and Settings left side panels (web). */
export const leftSidePanelWebWidth = '258px';
/** Slim rail when a web left pane is closed (10px + 30px toggle + 10px). */
export const leftSidePanelCollapsedWidth = '50px';
/** Shared width for Metrics, Audits, and Reporting left side panels (slide-in / tmp). */
export const leftSidePanelMobileWidth = '300px';
export const LEFT_SIDE_PANEL_MOTION_MS = 340;
export const leftSidePanelMotionEase = 'cubic-bezier(0.22, 1, 0.36, 1)';

/** Width / flex-basis open↔rail — web only; mobile tmp panes keep a fixed slide-in width. */
export const leftSidePanelWidthMotion = css<{ isWeb?: boolean, $open?: boolean }>`
  ${({ isWeb, $open = true }) => {
    const width = isWeb
      ? ($open ? leftSidePanelWebWidth : leftSidePanelCollapsedWidth)
      : leftSidePanelMobileWidth;
    return css`
      width: ${width};
      min-width: ${width};
      flex: 0 0 ${width};
      overflow: hidden;
      ${isWeb ? css`
        transition:
          width ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase},
          min-width ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase},
          flex-basis ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase};
        @media (prefers-reduced-motion: reduce) {
          transition: none;
        }
      ` : ''}
    `;
  }}
`;

/** Fade pane body while width collapses — no transform (keeps position:fixed menus on the viewport). */
export const leftSidePanelBodyMotion = css<{ $open?: boolean }>`
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  opacity: ${({ $open = true }) => ($open ? 1 : 0)};
  /* Delay visibility:hidden so the fade can finish; also drops the body from tab order. */
  visibility: ${({ $open = true }) => ($open ? 'visible' : 'hidden')};
  pointer-events: ${({ $open = true }) => ($open ? 'auto' : 'none')};
  transition: ${({ $open = true }) => (
    $open
      ? `opacity 260ms ${leftSidePanelMotionEase}, visibility 0ms`
      : `opacity 260ms ${leftSidePanelMotionEase}, visibility 0ms 260ms`
  )};
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const mobileRes2 = '480px';
const redColor = '#eb364b';
export const redColor2 = Color(redColor).lighten(0.1).toString();

export const Button = styled.div<{ bg?: string, hvBg?: string, color?: string, padding?: string, fontSize?: string }>`
  padding: ${({ padding }) => padding || '15px 25px'};
  padding-top: ${({ padding }) => !padding && '11px'}; 
  border-radius: 35px;
  color: ${({ color }) => color || 'white'};
  background: ${({ bg }) => bg || '#a38f18'};
  width: max-content;
  font-size: ${({ fontSize }) => fontSize || '17px'};
  font-weight: 700;
  cursor: pointer;
  &:hover {
    background: ${({ hvBg }) => hvBg || '#edd124'};
  }
`;
